import { useIntl } from "react-intl";

const Wrapper = ({JsxElement:Element, ...props}) => {
    const intl = useIntl();
    return <Element {...props} intl={intl} />
}
export default Wrapper;
